import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Route,
  Link as RouterLink,
  Routes,
  useLocation,
} from "react-router-dom";
import ExportJobsLogTable from "../../components/Compliance/ExportJobStatus";
import ActiveExportJobsSummary from "../../components/Compliance/ExportJobsSummary";
import { DatasetType, ExportType } from "../../types/Compliance";



const ExportJobsMain: React.FC<{}> = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<string>("");
  const [datasetType, setDatasetType] = useState<DatasetType>("delivery");
  const [intervalDays, setIntervalDays] = useState(14);
  const [exportType, setExportType] = useState<ExportType>("analysis");


  const tabs = [
    { name: "Active Jobs", path: "/data-ops/export-jobs" },
    { name: "Jobs Log", path: "/data-ops/export-jobs/job-status" },
  ];

  useEffect(() => {
    // Check if we're on the job-status path
    const isJobStatus = location.pathname.includes("/job-status");
    const currentTabIndex = isJobStatus ? 1 : 0;
    setSelectedTab(currentTabIndex);
    setSelectedTabName(tabs[currentTabIndex].name);
  }, [location.pathname]);

  useEffect(() => {
    document.title = `Export Jobs - ${selectedTabName}`;
  }, [selectedTabName]);

  return (
    <Box>
      <h1>Export Jobs</h1>

      {/* Tabs navigation */}
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>

      {/* Routes to render content */}
      <Routes>
        <Route
          path="/"
          element={<ActiveExportJobsSummary/>}
        />
        <Route
          path="job-status"
          element={
            <ExportJobsLogTable
              datasetType={datasetType}
              setDatasetType={setDatasetType}
              intervalDays={intervalDays}
              setIntervalDays={setIntervalDays}
              exportType={exportType}
              setExportType={setExportType}
            />
          }
        />
      </Routes>
    </Box>
  );
};

export default ExportJobsMain;